import React, { useState } from "react";
import DynamicIcon from './DynamicIcon';
import YouTube from "react-youtube";



const VideoSlideshow = () => {
  // const videoIds = ['jGM1jZqlpos', 'awbly5bkeJ0', 'bObqR70Bkjo', 'C1CfWO8YHnU', 'LClnLU957uk']
  const videoIds = ['jGM1jZqlpos', 'awbly5bkeJ0', 'C1CfWO8YHnU', 'LClnLU957uk']

  const [currentVideo, setCurrentVideo] = useState(0);

  const handlePrevVideo = () => {
    setCurrentVideo((currentVideo - 1 + videoIds.length) % videoIds.length);
  };

  const handleNextVideo = () => {
    setCurrentVideo((currentVideo + 1) % videoIds.length);
  };


  return (
    <div className="video-carousel-container">
      <div className="video-carousel-current">
        <YouTube videoId={videoIds[currentVideo]} />
      </div>
      <div className="video-carousel-thumbnails">
        {videoIds.map((videoId, index) => (
          <div
            key={index}
            className={`video-carousel-thumbnail ${
              index === currentVideo ? "active" : ""
            }`}
            onClick={() => setCurrentVideo(index)}
          >
            <img
              src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
              alt={`Thumbnail for video ${index}`}
            />
          </div>
        ))}
      </div>
      <div className="video-carousel-controls">
        <button aria-label="previous" onClick={handlePrevVideo}><DynamicIcon icon={"arrowCircleLeft"} id="icon"/></button>
        <button aria-label="next" onClick={handleNextVideo}><DynamicIcon icon={"arrowCircleRight"} id="icon"/></button>
      </div>
    </div>
  );
};

export default VideoSlideshow;